export default "__VITE_ASSET__0238e568__"